export default __webpack_public_path__ + "static/media/customer-1-min.9acacdb7.png";